import type { TFunction } from 'i18next';
import { ApiError } from '@/api/client';

const KNOWN = [
    'Conflict',
    'ValidationError',
    'UniqueConstraintError',
    'NotFound',
    'MercedesApiError',
    'MercedesNotConfigured',
    'VehicleNotConnectable',
    'ActivationNotAllowed',
] as const;
type Known = (typeof KNOWN)[number];

const isKnown = (name: string | null): name is Known => KNOWN.includes(name as Known);

/**
 * Text for a snackbar, or null when nothing should be shown (401 → the session logic takes over).
 * Unknown BE error names get the generic translated text; the raw BE message goes to the console.
 */
export function errorMessage(error: unknown, t: TFunction): string | null {
    if (error instanceof ApiError) {
        if (error.status === 401) {
            return null;
        }
        if (error.status === 0) {
            return t('common.networkError');
        }
        if (isKnown(error.errorName)) {
            return t(`errors.${error.errorName}`);
        }
    }
    console.error(error);
    return t('common.unexpectedError');
}
